/** @jsxImportSource @emotion/react */

import React, { ReactNode } from 'react';
import { CSSProp } from '../../../types/emotion';

export interface CenteredLayoutProps {
  /**
   * The content to center.
   */
  children: ReactNode;
}

export function CenteredLayout({
  children,
  ...props
}: CenteredLayoutProps & Omit<Partial<React.HTMLAttributes<HTMLDivElement>>, keyof CenteredLayoutProps> & CSSProp) {
  return (
    <div css={{ display: 'grid', placeContent: 'center', height: '100%' }} {...props}>
      {children}
    </div>
  );
}
